import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

export interface ConfirmRedirectDialogData {
  onConfirmRedirect: () => void;
  onCancel: () => void;
}

@Component({
  selector: 'app-confirm-redirect-popup',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressSpinner],
  templateUrl: './confirm-redirect-popup.component.html',
  styleUrls: ['./confirm-redirect-popup.component.css'],
})
export class ConfirmRedirectPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmRedirectPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmRedirectDialogData
  ) {}
  loading: boolean = false;

  confirmRedirect(): void {
    this.data.onConfirmRedirect();
    this.loading = true;

  }

  cancel(): void {
    this.data.onCancel();
    this.dialogRef.close();
  }
}
